import FormSelectInput from "./FormSelectInput";

const FormSelectRole = (props) => {
    const loadOptions = async (input) => {
        return [
            {value: 'WORKER', label: 'Worker'},
            {value: 'ADMIN', label: 'Admin'},
            {value: 'FOREMAN', label: 'Foreman'},
        ]
    }

    return (
        <FormSelectInput loadOptions={loadOptions} {...props} />
    )
}

export default FormSelectRole;